import {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";

const useBodyClass = () => {
    const location = useLocation();
    const [classNameList, setClassNameList] = useState<string | string[]>('');
    const [themeWrapperClassName, changeThemeWrapperClassName] = useState<string>('');

    useEffect(() => {
        let classList: string[] = [];

        if (themeWrapperClassName) {
            classList = getRouteClassList();
        }

        if (classNameList instanceof Array) {
            classList.concat(classNameList);
        }
        else if(classNameList) {
            classList.push(classNameList);
        }

        classList.map(addBodyClass);

        // Clean up
        return () => {
            classList.map(removeBodyClass);
        };

    }, [themeWrapperClassName, classNameList, location.pathname]);

    const setClassName = (className: string | string[]) => {
        setClassNameList(className);
    }

    const setThemeWrapperClassName = (className: string) => {
        changeThemeWrapperClassName(className);
    }

    const getRouteClassList = () => {
        const pathArr = location.pathname.split("/").map(item => item.toLocaleLowerCase());
        let classNameString: string = '';
        let classNameArr: string[] = [themeWrapperClassName];

        pathArr.forEach(value => {
            if (value) {
                classNameString += '_' + value;
            }
        });

        if (classNameString) {
            classNameArr.push(themeWrapperClassName + classNameString);
        }

        return classNameArr;
    }

    const addBodyClass = (className: string) => {
        document.body.classList.add(className)
    }

    const removeBodyClass = (className: string) => {
        document.body.classList.remove(className)
    }

    return { setThemeWrapperClassName, setClassName }
};

export default useBodyClass;